/**
 * Transactional email the platform sends on its own behalf.
 *
 * This file used to also hold an in-app inbox — email sync, threads, templates,
 * open and click tracking, provider connections. That went when the app stopped
 * trying to be a mail client: an agency's AI assistant is already connected to
 * their mailbox, and `emails`, `email_templates` and `email_connections` held
 * zero rows between them.
 *
 * What remains cannot move. A notification email goes to someone who may not be
 * signed in and has no assistant of their own, so the platform has to send it.
 */

import { pb } from '../lib/pocketbase'
import { NOREPLY_EMAIL } from '../lib/config'

/**
 * Send a notification email via Resend (api/send-email)
 * Sends directly without storing in database
 */
export async function sendNotificationEmail(payload: {
  to: string
  subject: string
  body: string
}): Promise<boolean> {
  
  const response = await fetch('/api/send-email', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${pb.authStore.token}`,
    },
    body: JSON.stringify({
      to: payload.to,
      subject: payload.subject,
      body: payload.body,
      from: NOREPLY_EMAIL,
      fromName: 'Reppr',
    }),
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Unknown error' }))
    throw new Error(`Failed to send notification email: ${error.message}`)
  }

  return true
}
